import React from 'react';

// Uma célula da grade. React.memo com PROPS PRIMITIVAS APENAS — é o que faz o Canvas
// (único consumidor de context) re-renderizar 1 célula ao digitar uma letra, não a
// grade inteira. Mesmo padrão de `crossword/Cell.tsx`.

export interface CellProps {
  x: number;
  y: number;
  letter: string;
  /** Faz parte de alguma palavra colocada. */
  inWord: boolean;
  /** Está na reta que o autor está arrastando agora. */
  dragging: boolean;
  /** Pertence à palavra selecionada no Inspector. */
  selected: boolean;
  /** É a célula do cursor do teclado (o que a digitação vai escrever). */
  isCursor: boolean;
  onMouseDown: (x: number, y: number) => void;
  onMouseEnter: (x: number, y: number) => void;
  onMouseUp: (x: number, y: number) => void;
}

const CellComponent: React.FC<CellProps> = ({
  x,
  y,
  letter,
  inWord,
  dragging,
  selected,
  isCursor,
  onMouseDown,
  onMouseEnter,
  onMouseUp,
}) => {
  const background = dragging ? '#bae7ff' : selected ? '#fff1b8' : inWord ? '#f6ffed' : '#fff';
  // `boxShadow` em vez de borda: 32×32 é tamanho fixo e engrossar a borda deslocaria
  // a grade inteira a cada movimento do cursor.
  const boxShadow = isCursor ? 'inset 0 0 0 2px #1677ff' : undefined;

  return (
    <div
      // O id é o alvo do `aria-activedescendant` da grade: o leitor de tela anuncia
      // esta célula quando o cursor do teclado chega nela.
      id={`ws-cell-${x}-${y}`}
      role="gridcell"
      aria-label={`x${x} y${y}`}
      data-testid={`cell-${x}-${y}`}
      onMouseDown={() => onMouseDown(x, y)}
      onMouseEnter={() => onMouseEnter(x, y)}
      onMouseUp={() => onMouseUp(x, y)}
      style={{
        width: 32,
        height: 32,
        border: '1px solid #d9d9d9',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: inWord ? 600 : 400,
        textTransform: 'uppercase',
        userSelect: 'none',
        cursor: 'pointer',
        background,
        boxShadow,
      }}
    >
      {letter}
    </div>
  );
};

export const Cell = React.memo(CellComponent);
